import { CruisePriceAndOffersV2Response } from "@silversea-ssc/dotcom-api-types/CruisePriceAndOffersV2";
import { FareCode, farePriority } from "@silversea-ssc/web-fares";

const unbundlingFares: FareCode[] = ["Plus", "Basic", "LastMinute"];

export const showOnlyUnbundlingFare =
  (enabled: boolean) =>
  <T extends { fare: FareCode }>(fare: T) => {
    if (!enabled) return true;

    return unbundlingFares.includes(fare.fare);
  };

export const showOnlyUnbindlingFareCode = (enabled: boolean) => {
  return (fareCode: FareCode) => {
    if (!enabled) return true;

    return unbundlingFares.includes(fareCode);
  };
};

export const unbundlingFareByPriority = (a: FareCode, b: FareCode) =>
  farePriority[b] - farePriority[a];
